import {ConstructionCategoryRequest, ConstructionCategoryStructRequest, ConstructionCategoryInteractor} from "../../Coordinator/ConstructionCategory/ConstructionCategoryInteractor";

export class ConstructionCategoryViewModel {
    private interactor: ConstructionCategoryInteractor;

    constructor() {
        this.interactor = new ConstructionCategoryInteractor();
    }

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new ConstructionCategoryRequest(
            obj["sgeptipoisencao"] ? parseInt(obj["sgeptipoisencao"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {  
            this.interactor.fetchSave(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new ConstructionCategoryStructRequest(
            obj["sgeptipoisencao"] ? parseInt(obj["sgeptipoisencao"]) : 0
        )
        
        return new Promise((res, rej) => {
            this.interactor.fetchDataOne(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
}
